module.exports = __webpack_public_path__ + "static/travel-award-2017-25aefb9a7db97a0f5addf50bf6c96124.svg";